import { z } from "zod";
import { PointType } from "./PointType";

export const LoyaltyDetailsModelSchema = z.object({
  promoOfferId: z.number().nullable(),
  standardOfferId: z.number().nullable(),
  promoCode: z.string().nullable(),
  membershipNumber: z.string().nullable(),
  pointType: z.nativeEnum(PointType).nullable(),
  flyBuysNumber: z.number().nullable(),
  flyBuysValid: z.boolean().nullable(),
  flyBuysValidated: z.boolean().nullable(),
  airPointsNumber: z.number().nullable(),
  airPointsFirstName: z.string().nullable(),
  airPointsLastName: z.string().nullable(),
  airPointsValid: z.boolean().nullable(),
  airPointsValidated: z.boolean().nullable(),
  promoCodeValid: z.boolean().nullable(),
  promoCodeComplete: z.boolean().nullable(),
  sectionComplete: z.boolean().nullable(),
});
